import { JsonObject } from '../../definitions/JsonObject';

export const FPTI_EVENT_NAMES = {
  PS_NAV: '{item_name}_{module}_{suffix}',
  PS_SUBNAV: 'dw_webnav_{module}_{suffix}',

  HEADER_LOGO: '{prefix}_header_logo_{suffix}',
  HEADER_LOGOUT: '{prefix}_header_logout_{suffix}',
  HEADER_SETTINGS: '{prefix}_header_settings_{suffix}',

  APP_BANNER_CLOSE: '{prefix}_appbanner_close_{suffix}',
  APP_BANNER_DOWNLOAD: '{prefix}_appbanner_download_{suffix}',
  APP_BANNER: '{prefix}_appbanner_{suffix}',
  APP_DESKTOP_BANNER: '{prefix}_app_desktop_banner_{suffix}',

  NOTIFICATIONS_ITEM: '{prefix}_notif_item_{suffix}',
  NOTIFICATIONS_CLOSE: '{prefix}_notif_close_{suffix}',
  NOTIFICATIONS_OPEN: '{prefix}_notif_open_{suffix}',
  NOTIFICATIONS_DISMISS: '{prefix}_notif_dismiss_{suffix}',
  NOTIFICATIONS_BADGE: '{prefix}_notif_badge_{suffix}',
};

const NAV_TRACKING_PAGE = 'main:walletweb:navigation::main';
const SPACE_KEY = 'SKHBDF';
const COMPONENT = 'commonutilsnodeserv';

export const FPTI_BASE_PROPS = {
  comp: COMPONENT,
  space_key: SPACE_KEY,
};

const FPTI_BASE_NAV_PROPS = {
  ...FPTI_BASE_PROPS,
  page: NAV_TRACKING_PAGE,
  pgrp: NAV_TRACKING_PAGE,
};

const FPTI_EVENT_NAME_PREFIX = 'dw_webnav';
export const FPTI_EVENT_TYPE_SUFFIXES = {
  im: 'shown',
  av: 'loaded',
  cl: 'pressed',
  impression: 'shown',
  load: 'loaded',
  click: 'pressed',
};

const FPTI_EVENT_TYPE_ATTRIBUTES = {
  im: 'data-cwt-fpti-im',
  av: 'data-cwt-fpti-av',
  cl: 'data-cwt-fpti-cl',
};

export function getBaseNavFptiProps(encryptedAccountNumber) {
  return {
    ...FPTI_BASE_NAV_PROPS,
    cust: encryptedAccountNumber,
  };
}

export function eventNameForType(eventNameTemplate, type, eventNameProps = {}) {
  const processedEventName = fptiEventName(eventNameTemplate, {
    ...eventNameProps,
    suffix: FPTI_EVENT_TYPE_SUFFIXES[type],
  });
  return processedEventName;
}

export interface FptiEventAttributesProps {
  eventName: string | [string, JsonObject];
  widgetName?: string;
  base?: JsonObject;
  impression?: JsonObject | boolean;
  load?: JsonObject | boolean;
  click?: JsonObject | boolean;
  linkName?: string;
}
export function fptiEventAttributes({
  eventName,
  base,
  impression,
  load,
  click,
}: FptiEventAttributesProps): JsonObject {
  const fptiBaseProps = {
    ...(base || {}),
  };
  const eventAttributesForType = (type, props) => {
    if (!props) {
      return {};
    }
    let eventNameTemplate = eventName;
    let eventNameProps = {};
    if (Array.isArray(eventName)) {
      eventNameTemplate = eventName[0];
      eventNameProps = eventName[1];
    }
    const processedEventName = eventNameForType(eventNameTemplate, type, eventNameProps);
    if (processedEventName.includes('{')) {
      throw new Error(
        `FPTI event name "${processedEventName}" is not fully defined. Please provide all required properties.`,
      );
    }
    const json = {
      ...(props === true ? {} : props),
      event_name: processedEventName,
    };
    return {
      [FPTI_EVENT_TYPE_ATTRIBUTES[type]]: JSON.stringify(json),
    };
  };

  return {
    ...(Object.keys(fptiBaseProps).length ? { 'data-cwt-fpti-base': JSON.stringify(fptiBaseProps) } : {}),
    ...eventAttributesForType('cl', click),
    ...eventAttributesForType('im', impression),
    ...eventAttributesForType('av', load),
  };
}

export function getLegacyFptiBaseProps(page) {
  return {
    page: `main:walletweb:summary:main:${page}`,
    pgrp: 'main:walletweb:summary::main',
    vers: 'customer',
    ...FPTI_BASE_PROPS,
  };
}

export function getLegacyFptiLinkProps(page, link) {
  return {
    pglk: `main:walletweb:summary:main:${page}|${link}`,
    pgln: `main:walletweb:summary:main:${page}|${link}`,
    link,
  };
}

export function fptiEventName(template, props = {}) {
  const eventProps = {
    prefix: FPTI_EVENT_NAME_PREFIX,
    ...props,
  };
  return Object.entries(eventProps).reduce((eventName, [key, value]) => {
    return eventName.replace(`{${key}}`, value);
  }, template);
}

export function getNotificationsFptiBaseProps({ locale, country, encryptedAccountNumber, correlationId }) {
  return {
    ...FPTI_BASE_PROPS,
    page: 'main:walletweb:notificationcenter::main',
    pgrp: 'main:walletweb:notificationcenter::main',
    vers: 'customer',
    pgtf: 'Nodejs',
    rsta: locale,
    ccpg: country,
    cust: encryptedAccountNumber,
    lcid: correlationId,
    domain_type: 'NOTIFICATION_CENTER',
    card_type: ' ',
    card_id: ' ',
    COORD_X: ' ',
  };
}

export function getNotificationBadgeFptiBaseProps({
  locale,
  country,
  encryptedAccountNumber,
  correlationId,
  badgeCount,
}) {
  // This function is used to
  return {
    ...getLegacyFptiBaseProps('notificationcenter'),
    rsta: locale,
    ccpg: country,
    cust: encryptedAccountNumber,
    lcid: correlationId,
    msgcd: badgeCount,
  };
}
